export * from './translation.config';
export * from './translation.module';
export * from './translation.locales';
